import { Card } from "../../components/Card";
import { Loading } from "../../components/Loading/Loading";
import { LottieLoading } from "../../components/Loading/LottieLoading";
import { ReactComponent as ArrowDown } from "../../assets/icons/left-arrow.svg";

export default function ReportTable({ data, cohorts, isLoading, error, sortBy, sortDirection, onSort }: { data: any[], cohorts: any[], isLoading: boolean, error: any, sortBy: string, sortDirection: string, onSort: (sortBy: string) => void }) {

    return (
        <Card className="h-full">
            {/** scrollable table body */}
            <div className="h-[calc(100vh-220px)] overflow-y-auto">
                <table className="w-full">
                    <thead className="sticky top-0 bg-white">
                        <tr className="text-lg [&>th]:text-left font-semibold">
                            <th className="flex items-center gap-2 cursor-pointer" onClick={() => {
                                onSort('name');
                            }}>
                                Name
                                {sortBy === 'name' && <ArrowDown className={`w-4 h-4 [&_path]:fill-black ${sortDirection === 'DESC' ? 'rotate-[270deg]' : 'rotate-90'}`} />}
                            </th>
                            <th>Cohort
                                {/* {sortBy === 'cohort' && <ArrowDown className={`w-4 h-4 [&_path]:fill-black ${sortDirection === 'DESC' ? 'rotate-[270deg]' : 'rotate-90'}`} />} */}
                            </th>
                            <th className="cursor-pointer" onClick={() => {
                                onSort('complete');
                            }}>
                                <div className="flex items-center gap-2">
                                    Completed Sessions
                                    {sortBy === 'complete' && <ArrowDown className={`w-4 h-4 [&_path]:fill-black ${sortDirection === 'DESC' ? 'rotate-[270deg]' : 'rotate-90'}`} />}
                                </div>
                            </th>
                            <th className="flex items-center gap-2 cursor-pointer" onClick={() => {
                                onSort('incomplete');
                            }}>Incomplete Sessions
                                {sortBy === 'incomplete' && <ArrowDown className={`w-4 h-4 [&_path]:fill-black ${sortDirection === 'DESC' ? 'rotate-[270deg]' : 'rotate-90'}`} />}
                            </th>
                        </tr>
                    </thead>
                    <tbody className="[&_td]:py-2">
                        {!isLoading && data.map((item, index) => (
                            <tr className="text-[17px]" key={index}>
                                <td>{item.name}</td>
                                <td>{cohorts?.find((cohort) => cohort.key === item.cohort)?.name || 'N/A'}</td>
                                <td>{item.complete}</td>
                                <td>{item.incomplete}</td>
                            </tr>
                        ))}

                        {isLoading && (
                            <tr>
                                <td colSpan={4} className="text-center">
                                    <LottieLoading className="h-[calc(100vh-300px)]" />
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
                {
                    !isLoading && data.length === 0 && (
                        <div className="text-center w-full h-[calc(100vh-300px)] flex items-center justify-center">No data found</div>
                    )
                }
            </div>
        </Card>
    )
}